export const DELETE_FILE = 'file/DELETE'

export interface FileActionImpl {
  type: string
  payload: Number
}
